var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"studios studios-page-list"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"studios-table"},[_c('ViewBarStudios'),_c('StudiosTable')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }